import { request, resetCustomOnResponseError, setCustomOnResponseError } from './axios'
import { Import, Export, ImportAd, ExportAd } from '../type/admin'
import { customErrorResponse } from '../utility/custom-error-response'

export const Synchronization = {
  export: async (): Promise<Export> => {
    const { data } = await request({
      url: '/datasync/export/',
      method: 'post',
    })

    return data
  },

  import: async (): Promise<Import> => {
    const { data } = await request({
      url: '/datasync/import/',
      method: 'post',
    })

    return data
  },

  exportAd: async (): Promise<ExportAd> => {
    setCustomOnResponseError(customErrorResponse)
    try {
      const { data } = await request({
        url: '/datasync/export/ad/',
        method: 'post',
      })
      return data
    } finally {
      resetCustomOnResponseError()
    }
  },
  importAd: async (): Promise<ImportAd> => {
    setCustomOnResponseError(customErrorResponse)
    try {
      const { data } = await request({
        url: '/datasync/import/ad/',
        method: 'post',
      })
      return data
    } finally {
      resetCustomOnResponseError()
    }
  },
}
